"use client";

import { useSafeRequestSwr } from "@osn/auth";
import { AccountService, ApiRequestOptions } from "osn-participantapi-client";

export function useMyAccount(enabled: boolean = true) {
  const callback = async (options: ApiRequestOptions) => await AccountService.getMyAccount(options);
  const key = enabled ? ["AccountService.getMyAccount"] : null;
  return useSafeRequestSwr(callback, key);
}

export function useMyAccountPhoto() {
  const callback = async (options: ApiRequestOptions) => await AccountService.getPhoto(options);
  const key = ["AccountService.getPhoto"];
  return useSafeRequestSwr(callback, key);
}
